import "./spinner.styles";
import { StyledSpinnerOverlay, StyledSpinnerContainer } from "./spinner.styles";

const Spinner = () => (
  <StyledSpinnerOverlay>
    <StyledSpinnerContainer />
  </StyledSpinnerOverlay>
);
export default Spinner;
